/*
 *   File : login.js
 *   Author : https://evoqins.com
 *   Description : login component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { useRef, useState, useEffect } from "react";
import { Input, OtpInput, Password } from "../../Components/FormElements";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { PrimaryButton } from "../../Components/Buttons";
import Icon from "../../Components/icons";
import { APIService } from "../../Service";

export default function Login() {
  const otpInputRef = useRef(null);
  // const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [otpModal, setOtpModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [otpValue, setOtpValue] = useState("");
  const [focusedInput, setFocusedInput] = useState(2);
  const [confirmOTP, setConfirmOTP] = useState([]);
  const [otpError, setOtpError] = useState("");
  const [counter, setCounter] = useState(10);
  const [startCounter, setStartCounter] = useState(false);

  //otp input
  useEffect(() => {
    if (otpInputRef) return;
    otpInputRef.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (!otpModal) return;

    setCounter(10);

    const t = setInterval(() => {
      setCounter((prev) => {
        if (prev <= 0) {
          clearInterval(t);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(t); // Cleanup interval on unmount or modal close
  }, [otpModal, startCounter]);

  useEffect(() => {
    setEmailError("");
  }, [email]);

  useEffect(() => {
    setPasswordError("");
  }, [password]);

  useEffect(() => {
    setOtpError("");
  }, [otpValue]);

  const _validateLogin = () => {
    let isValid = true;

    // Reset errors first
    setEmailError("");
    setPasswordError("");

    let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;

    // Validate Email
    if (!email.trim()) {
      setEmailError("Username is required");
      isValid = false;
    } else if (!validate_email.test(email)) {
      setEmailError("Please provide a valid email");
      isValid = false;
    }

    // Validate Password
    if (!password.trim()) {
      setPasswordError("Password is required");
      isValid = false;
    }

    if (isValid) {
      _handleLogin();
    }
  };

  // API - Handle Login
  const _handleLogin = () => {
    setLoading(true);
    let is_post = true;
    let url = "auth/login";
    let data = {
      email: email,
      password: password,
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        toast.success(response.message);
        setOtpModal(true);
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
      setLoading(false);
    });
  };

  const _validateOtp = () => {
    if (otpValue.length < 4) {
      setOtpError("Enter received OTP");
      return;
    }
    if (otpValue.length === 4) {
      _verifyOtp();
    }
  };

  // API - Verify OTP
  const _verifyOtp = () => {
    setLoading(true);

    let is_post = true;
    let url = "auth/verify-otp";
    let data = {
      email: email,
      otp: otpValue,
      type: "LOGIN",
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        console.log(response);
        setOtpValue("");
        setConfirmOTP([]);
        Cookies.set("access_token", response.access_token, {
          path: "/",
          sameSite: "None",
          secure: true,
          ...(process.env.REACT_APP_DOMAIN && {
            domain: process.env.REACT_APP_DOMAIN,
          }),
        });
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
        window.location.replace("/");
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
        setOtpValue("");
        setConfirmOTP([]);
      }
      setLoading(false);
    });
  };

  // on successful OTP verification
  const _handleSubmitOTP = () => {
    _validateOtp();
  };

  // handle OTP
  const _handleOTP = (e) => {
    if (loading !== true) {
      const rawValue = e.target.value;

      // Check for non-numeric characters
      if (/[^0-9]/.test(rawValue)) {
        setOtpError("Enter only numbers");
        return; // stop here, do not update OTP
      }

      setOtpError("");

      if (rawValue.length <= 4) {
        setOtpValue(rawValue);
        const characters = [];
        for (let i = 0; i < rawValue.length; i++) {
          const character = rawValue.charAt(i);
          characters.push(character);
        }
        setConfirmOTP(characters);
      }
    }
  };

  // API - Resend OTP
  const _handleResendOTP = () => {
    setOtpValue("");
    setConfirmOTP([]);
    setCounter(10);
    setStartCounter(!startCounter);

    let is_post = true;
    let url = "auth/resend";
    let data = {
      email: email,
      type: "LOGIN",
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        setOtpValue("");
        setConfirmOTP([]);
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
    });
  };

  return otpModal ? (
    <>
      <Link
        to="#"
        className="text-decoration-none d-flex align-items-center pb-3 ps-22"
        onClick={() => {
          setOtpModal(false);
          setOtpValue("");
          setConfirmOTP([]);
        }}
      >
        <Icon icon="arrow-left" size={20} color="black" />
      </Link>
      <div className="e-glass-card  p-24 d-flex flex-column w-100 rounded-30 rg-24">
        <h3 className="fs-24 fw-600 mb-0">{"OTP Verification"}</h3>
        <div className="d-flex align-items-center column-gap-3">
          <div className="d-flex flex-column">
            <OtpInput
              label="Enter OTP"
              ref={otpInputRef}
              id="otp"
              value={otpValue}
              spellcheck="false"
              error={otpError}
              require={true}
              focused_input={focusedInput}
              confirm_pin={confirmOTP}
              onFocus={() => setFocusedInput(2)}
              onBlur={() => setFocusedInput(0)}
              onKeyPress={_handleSubmitOTP}
              onChange={_handleOTP}
            />
          </div>
          <p className="fw-400 fs-12 lh-16 text-granite-gray mb-0 pt-3 ">
           {` 00:${counter}s`}
          </p>
        </div>
        <p className="fw-400 fs-12 mb-0 lh-16 text-granite-gray text-decoration-none e-transition-opacity">
          {"Didn't get an OTP?"}
          <PrimaryButton
            disabled={counter !== 0}
            onPress={_handleResendOTP}
            ClassName="fw-400 fs-12 lh-16 bg-transparent p-1 text-facebook-blue"
            name={"Resend OTP"}
          />
        </p>
        <div className="w-100">
          <PrimaryButton
            ClassName="rounded-pill bg-midnight-blue lh-1 py-15_5 text-white  w-100 fs-14 fw-600"
            name="Verify"
            loading={loading}
            onPress={_handleSubmitOTP}
          />
        </div>
      </div>
    </>
  ) : (
    <div className="e-glass-card p-24 d-flex flex-column  w-100 rounded-30">
      <h3 className="fs-24 fw-600 mb-0 pb-24">{"Admin Login"}</h3>

      <div className="d-flex flex-column row-gap-2">
        <Input
          id="1"
          type="text"
          label="Username"
          placeholder="Enter username"
          require={true}
          value={email}
          error={emailError}
          onKeyPress={_validateLogin}
          className="w-100 px-3 py-10"
          handleChange={(e) => {
            (setEmail(e), setEmailError(""));
          }}
          autoFocus={true}
        />

        <Password
          id="2"
          label="Password"
          placeholder="Enter Password"
          require={true}
          value={password}
          error={passwordError}
          onKeyPress={_validateLogin}
          className="w-100 px-3 py-10"
          handleChange={(e) => {
            (setPassword(e), setPasswordError(""));
          }}
        />

        <Link
          to={"/forgot-password"}
          className="fw-400 fs-12 lh-16 text-end text-facebook-blue text-decoration-none e-transition-opacity"
        >
          {"Forgot Password"}
        </Link>
      </div>
      <div className="pt-24 w-100">
        <PrimaryButton
          ClassName="rounded-pill bg-midnight-blue lh-1 py-15_5 text-white  w-100 fs-14 fw-600"
          name="Login"
          loading={loading}
          onPress={_validateLogin}
        />
      </div>
    </div>
  );
}
